<template>
  <lottery-popup
    :showPrize="showPrize"
    :prizePicture="prizePicture"
    :lotteryResult="lotteryResult"
    @close="changeShowPrize"
    @gotoLink="gotoLink"
    @clickConfirm="clickConfirm"
  ></lottery-popup>
</template>

<script>
import LotteryPopup from '@this/components/Popup/LotteryPopup';
import { mapState, mapActions } from 'vuex';

export default {
  computed: {
    ...mapState('lottery', ['showPrize', 'lotteryResult']),
    ...mapState('config', ['prizePicture']),
  },
  methods: {
    ...mapActions('lottery', ['changeShowPrize', 'clickConfirm']),
    ...mapActions('goto', ['gotoLink']),
  },
  components: {
    LotteryPopup,
  },
};
</script>
